<template>
  <div v-if="isBlackFriday()">
    <strong>{{ prefix }} <span style="font-family: monospace, monospace;">{{ time }}</span> {{this.$t('COUNTDOWN_PREFIX_BF_SUFFIX')}}</strong>
  </div>
  <div v-else-if="isChristmas()">
    <strong>{{ prefix }} <span style="font-family: monospace, monospace;">{{ time }}</span> {{this.$t('COUNTDOWN_PREFIX_BF_SUFFIX')}}</strong>
  </div>
  <div v-else>
    {{this.$t('COUNTDOWN_PREFIX')}}<span style="font-family: monospace, monospace;"><strong> {{ time }}</strong></span> {{ suffix }}
  </div>
</template>

<script>
export default {
  data: function(){
    return{
      prefix:"",
      time:"",
      suffix:"",
    };
  },
  mounted(){
    this.timerCount();
    this.interval = setInterval(() => {
      this.timerCount();
    }, 1000);
  },
  methods: {
    isBlackFriday: function () {
      return Math.floor(Date.now() / 1000) < 1733180400
    },
    isChristmas: function () {
      return Math.floor(Date.now() / 1000) < 1703977200
    },
    timerCountBf: function(){
      // Get todays date and time
      let bft = 1733180400
      var now = new Date();
      var t = Math.floor(Date.now() / 1000);
      var d = now.getDate();
      var h = now.getHours();
      var m = now.getMinutes();
      var s = now.getSeconds();

      if (t < bft - 4 * 86400) {
        this.prefix = this.$t('COUNTDOWN_PREFIX_BF_PREFIX_BLACK_WEEK')
        let targetDate = new Date((bft - 4 * 86400) * 1000);
        let differenceInTime = targetDate - now;
        d = Math.floor(differenceInTime / (1000 * 60 * 60 * 24));
      } else if (t < bft - 3 * 86400) {
        this.prefix = this.$t('COUNTDOWN_PREFIX_BF_PREFIX_BLACK_FRIDAY')
        let targetDate = new Date((bft - 3 * 86400)* 1000);
        let differenceInTime = targetDate - now;
        d = Math.floor(differenceInTime / (1000 * 60 * 60 * 24));
      } else if (t < bft - 86400) {
        this.prefix = this.$t('COUNTDOWN_PREFIX_BF_PREFIX_BLACK_WEEKEND')
        let targetDate = new Date((bft - 86400)* 1000);
        let differenceInTime = targetDate - now;
        d = Math.floor(differenceInTime / (1000 * 60 * 60 * 24));
      } else {
        this.prefix = this.$t('COUNTDOWN_PREFIX_BF_PREFIX_CYBER_MONDAY')
        d = 0;
      }

      var dStr = this.prefixZeroIfNecessary(d);
      if (dStr !== '') {
        dStr = dStr + 'd '
      }

      var hStr = this.prefixZeroIfNecessary(23 - h);
      if (hStr !== '') {
        hStr = hStr + 'h '
      }

      var mStr = this.prefixZeroIfNecessary(59 - m);
      if (mStr !== '' || hStr !== '') {
        if (mStr === '') {
          mStr = '00'
        }
        mStr = mStr + 'min '
      }

      var sStr = this.prefixZeroIfNecessary(59 - s);
      if (sStr !== '' || mStr !== '') {
        if (sStr === '') {
          sStr = '00'
        }
        sStr = sStr + 's '
      }

      this.time = dStr + hStr + mStr + sStr
    },
    timerCountChristmas: function(){
      this.prefix = 'Winter Sale:'

      // Get todays date and time
      var now = new Date();
      var d = now.getDate();
      var h = now.getHours();
      var m = now.getMinutes();
      var s = now.getSeconds();

      // 31.12.2023 last sale day
      let bwDay = 31
      d = bwDay - d;

      var dStr = this.prefixZeroIfNecessary(d);
      if (dStr !== '') {
        dStr = dStr + 'd '
      }

      var hStr = this.prefixZeroIfNecessary(23 - h);
      if (hStr !== '') {
        hStr = hStr + 'h '
      }

      var mStr = this.prefixZeroIfNecessary(59 - m);
      if (mStr !== '' || hStr !== '') {
        if (mStr === '') {
          mStr = '00'
        }
        mStr = mStr + 'min '
      }

      var sStr = this.prefixZeroIfNecessary(59 - s);
      if (sStr !== '' || mStr !== '') {
        if (sStr === '') {
          sStr = '00'
        }
        sStr = sStr + 's '
      }

      this.time = dStr + hStr + mStr + sStr
    },
    timerCount: function(){
      if (this.isBlackFriday()) {
        this.timerCountBf()
        return
      }
      if (this.isChristmas()) {
        this.timerCountChristmas()
        return;
      }
      // Get todays date and time
      var now = new Date();
      var d = now.getDay();
      var h = now.getHours();
      var m = now.getMinutes();
      var s = now.getSeconds();

      var x = 23;
      if (h < 12 && d !== 6 && d !== 0) {
        x = 11;
        this.suffix = this.$t('COUNTDOWN_SUFFIX_1')
      } else if (h >= 12 && d < 5) {
        this.suffix = this.$t('COUNTDOWN_SUFFIX_2')
      } else {
        if (h < 12) {
          x = 11;
        }
        this.suffix = this.$t('COUNTDOWN_SUFFIX_3')
      }

      var hStr = this.prefixZeroIfNecessary(x - h);
      if (hStr !== '') {
        hStr = hStr + 'h '
      }

      var mStr = this.prefixZeroIfNecessary(59 - m);
      if (mStr !== '' || hStr !== '') {
        if (mStr === '') {
          mStr = '00'
        }
        mStr = mStr + 'min '
      }

      var sStr = this.prefixZeroIfNecessary(59 - s);
      if (sStr !== '' || mStr !== '') {
        if (sStr === '') {
          sStr = '00'
        }
        sStr = sStr + 's '
      }

      this.time = hStr + mStr + sStr
    },
    prefixZeroIfNecessary: function(i) {
      if (i == 0) {
        return ''
      }
      if (i < 10) {
        return '0'+i
      }
      return ''+i
    }
  }
};
</script>
